/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect, useContext } from "react";
import Sidebar from "../Sidebar";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { ChatContext } from "../../contexts/ChatContext";
import ChatHome from "./ChatHome";
import Avatar from "../Avatar";
import TextareaAutosize from "react-textarea-autosize";
import { FiPlus, FiArrowRight } from "react-icons/fi"; // Import FiEdit for the pen icon
import { PiSpeakerHigh, PiSpeakerSlash } from "react-icons/pi";
import { IoIosClose } from "react-icons/io";
import { useSelector } from "react-redux";
import { startChat, sendMessage } from "./ChatService";
import { RemoveChatContext } from "../../contexts/RemoveChatContext";
import uploadFile from "../../helper/uploadFiles";
import logo from "../../assets/GemX.png"
// Function to format the text based on the given rules
const formatText = (text) => {
  let filterText = text.replace(/##/g, '')
  let responseArray = filterText.split("**");
  let newResponse = "";
  for (let i = 0; i < responseArray.length; i++) {
    if (i === 0 || i % 2 !== 1) {
      newResponse += responseArray[i];
    } else {
      newResponse += "<b>" + responseArray[i] + "</b>";
    }
  }
  let newResponse2 = newResponse.split("*").join("<b>•</b>");
  let newResponse3 = newResponse2
    .split("\n")
    .map((line, index, lines) => {
      if (line.includes("•") && index < lines.length - 1) {
        return line + "<br>" + lines[index + 1];
      }
      return line;
    })
    .filter((line, index, lines) => !lines[index - 1]?.includes("•"))
    .join("<br>");
  return newResponse3;
};


const Chat = () => {
  const user_id = localStorage.getItem("user_id");
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const uploadImageRef = useRef(null);
  const [searchParams, setSearchParams] = useSearchParams("");
  const [messages, setMessages] = useState([]);
  const [uploadPhoto, setUploadPhoto] = useState({
    imageUrl: "",
  })
  const [uploadOriginal, setUploadOriginal] = useState("")
  const [speak, setSpeak] = useState(true);
  const [loading, setLoading] = useState(false);
  const { sideChat, setSideChat, sideId,sessionId,setSessionId,startNewSession } = useContext(ChatContext);
  const { userid } = useContext(RemoveChatContext);
  const [input, setInput] = useState("");
  const [sideClick, setSideClick] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [chatHomeVisible, setChatHomeVisible] = useState(true);
  const { user } = useSelector((state) => state.auth);


  useEffect(() => {
    if (sessionId === null || !sessionId) {
      startNewSession();
    }
  }, [sessionId]);

  useEffect(() => {
    if (sessionId) {
      const currentUrl = new URL(window.location.href);
      const pathSegments = currentUrl.pathname.split("?id=");

      if (pathSegments.length > 1) {
        // If the last segment is a sessionId, remove it
        pathSegments.pop();
      }

      // Add the new sessionId
      pathSegments.push(localStorage.getItem("sessionId"));
      setSearchParams({ id: sessionId });
      const newUrl = `${currentUrl.origin}${pathSegments.join("?id=")}`;

      window.history.pushState({ path: newUrl }, "", newUrl);
    }
  }, [sessionId]);


  useEffect(() => {
    //localStorage.setItem("searchParams",searchParams)
    loadChatMessages(searchParams.get("id"));
  }, [searchParams]);

  useEffect(() => {
    if (sideId) {
      setSideClick(true);
      setChatHomeVisible(false);
    }
    localStorage.setItem("sessionId", sideId);
    setSessionId(sideId);
  }, [sideId]);

  useEffect(() => {
    if (userid) {
      setMessages([]);
      setSideChat([]);
      if (!sessionId) {
        const currentUrl = new URL(window.location.href);
        const pathSegments = currentUrl.pathname.split("?id=");

        if (pathSegments.length > 1) {
          // If the last segment is a sessionId, remove it
          pathSegments.pop();
        }

        pathSegments.push(startNewSession());
        setSearchParams({ id: sessionId });
        const newUrl = `${currentUrl.origin}${pathSegments.join("?id=")}`;

        window.history.pushState({ path: newUrl }, "", newUrl);
      }
    }
  }, [userid]);

  /* useEffect(() => {
    const handleFocus = () => {
      if (inputRef.current) {
        inputRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    };

    const textarea = document.querySelector("textarea");
    if (textarea) {
      textarea.addEventListener("focus", handleFocus);
      return () => {
        textarea.removeEventListener("focus", handleFocus);
      };
    }
  }, []); */

  useEffect(() => {
    async function initializeChat() {
      await startChat();

      await startChat(
        sideChat.map((chat) => ({
          role: chat.sender === "user" ? "user" : "model",
          parts: [{ text: chat.text }],
        }))
      );
    }
    initializeChat()
  }, [messages])


  const loadChatMessages = async (sessionId) => {
    const URL = `http://localhost:3001/conversation/sideChatRetrieve/${sessionId}`;
    try {
      const response = await axios.get(URL);
      if (response.data) {
        const allChats = response.data.chats;
        const chats = allChats.map((chat) => ({
          text: formatText(chat.text),
          image: chat.image,
          sender: chat.sender,
        }));

        setSideChat(chats);
      }
    } catch (error) {
      console.error("Error loading chat messages:", error);
    }
  };

  const handleUploadImage = async (e) => {

    const file = e.target.files[0];
    setUploadOriginal(file)

    const uploadPhoto = await uploadFile(file);
    setUploadPhoto(prev => {
      return {
        ...prev,
        imageUrl: uploadPhoto.url
      }
    })
  }




  const handleFile = () => {
    if (uploadImageRef.current) {
      uploadImageRef.current.click()
    }
  }
  const handleClearUploadPhoto = () => {
    setUploadPhoto(prev => {
      return {
        ...prev,
        imageUrl: ""
      }
    })
  }
  const handleSend = async () => {
    setChatHomeVisible(false);
    setInput("");
    setUploadPhoto(prev => {
      return {
        ...prev,
        imageUrl: ""
      }
    })
    if (input.trim()) {
      const URL = `https://gemxbackend.onrender.com/conversation/userChat`;
      const userMessage = { text: input, title: input, image: uploadPhoto.imageUrl, sender: "user" };
      setMessages([...messages, userMessage]);
      setSideChat([...sideChat, userMessage]);
      await axios.post(URL, {
        sessionId,
        user_id,
        title: input,
        text: input,
        image: uploadPhoto.imageUrl,
        sender: "user",
      });
      setLoading(true);
      const historyRestoreResponse = await sendMessage(input, uploadOriginal);
      const botResponse = historyRestoreResponse;
      const formattedBotResponse = formatText(botResponse);
      const botMessage = { text: formattedBotResponse, sender: "Gemx" };
      setMessages([...messages, userMessage, botMessage]);
      setSideChat([...sideChat, userMessage, botMessage]);
      setLoading(false);
      await axios.post(URL, {
        sessionId,
        user_id,
        text: botResponse,
        sender: "Gemx",
      });
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  });

  const handleEndSession = () => {
    setSessionId("");
    localStorage.removeItem("sessionId");
    setMessages([]);
    navigate("/app");
    setSideClick(false);
    if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
    }
    window.location.reload();
  };

  const handleKeyPress = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSend();
    }
  };



  const handleMessage = async () => {
    setMessages([]);
    setSideChat([]);
    startNewSession();
    setChatHomeVisible(true);
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === "F") {
        e.preventDefault();
        toggleSidebar();
      } else if (e.ctrlKey && e.shiftKey && e.key === "P") {
        e.preventDefault();
        navigate("/app");
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate]);

  const speakText = (text) => {
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = 'en-US'; // Set the language if needed
      window.speechSynthesis.speak(utterance);
    } else {
      console.error('Text-to-Speech not supported in this browser.');
    }
  };


  return (
    <div className="min-h-screen bg-transparent flex flex-col">
      {/* ChatHome Visibility Wrapper */}
      <div className={chatHomeVisible ? "visible-style" : "hidden-style"}>
        <ChatHome isOpen={isOpen} />
      </div>

      {/* Main Content */}
      <div className="flex-grow flex h-screen overflow-hidden text-white relative">
        {/* Sidebar */}
        <Sidebar
          isOpen={isOpen}
          toggleSidebar={toggleSidebar}
          setMessages={handleMessage}
          response={messages}
        />

        {/* Main Chat Section */}
        <div
          className={`flex flex-col flex-grow transition-width duration-300 ${isOpen ? "w-full md:w-3/4" : "w-full md:w-full"
            }`}
        >
          {/* Toggle Button (Top Left Corner) */}
          <button
            className="absolute top-8 left-4 flex items-center justify-center h-8 w-8 text-white"
            onClick={toggleSidebar}
          >
            <img
              src="https://img.icons8.com/?size=100&id=eMQsFGlY7TA4&format=png&color=999999"
              alt="sidebar"
              className="h-8 w-8"
            />
          </button>

          {/* Navbar */}
          <div className="p-3 flex items-center justify-between">
            <button
              className="flex items-center justify-center h-8 w-8 ml-6 md:ml-6 -mt-2 md:mt-"
              onClick={handleEndSession}
            >
              <img
                src="https://img.icons8.com/?size=100&id=EiJnl8UJCjVI&format=png&color=999999"
                alt="Home"
                className="h-8 w-8 ml-7 mt-7"
              />
            </button>

            <div className="flex-1 flex justify-center">
              <span
                className="self-center mt-4 whitespace-nowrap text-3xl font-bold text-white cursor-pointer"
                onClick={() => navigate("/app")}
              >
                GemX
              </span>
            </div>

            <div className="flex items-center justify-end space-x-2">
              <button className="h-7 w-7 md:h-11 md:w-11 rounded-full flex items-center justify-center text-white dark:bg-gray-700 bg-slate-300">
                <Avatar
                  width={40}
                  height={40}
                  name={user?.firstName}
                  imageUrl={user?.profile_pic}
                  userId=""
                  rounded
                />
              </button>
            </div>
          </div>

          {/* Chat Messages */}
          <div className="flex-grow p-6 mb-8 overflow-y-auto custom-scrollbar chat">
            <div
              className="p-4 md:p-6 w-full max-w-[800px] mx-auto space-y-4"
              ref={inputRef}
            >
              {sideClick
                ? sideChat.map((msg, index) => (
                  <div
                    key={index}
                    className={`flex items-start space-x-2 ${msg.sender === "user" ? "justify-end" : "justify-start"
                      }`}
                  >
                    {msg.sender !== "user" && (
                      <div className="flex-shrink-0">
                        <div
                          className={`h-6 w-6 md:h-10 md:w-10 rounded-full flex items-center justify-center text-white ${msg.sender === "user"
                            ? "dark:bg-custom bg-slate-200"
                            : "dark:bg-gray-800 bg-slate-300"
                            }`}
                        >
                          {msg.sender !== "user" ? <img src={logo} alt="G" /> : null}
                        </div>
                      </div>
                    )}
                    <div
                      className={`p-2 md:p-4 rounded-lg max-w-[95%] md:max-w-[93%] break-words ${msg.sender === "user"
                        ? "dark:bg-custom bg-slate-200 text-white rounded-full"
                        : "dark:bg-gray-800 bg-slate-300 text-white rounded-full"
                        }`}
                    >
                      {msg.sender === "Gemx" ? (
                        <div dangerouslySetInnerHTML={{ __html: msg.text }} />
                      ) : (
                        msg.text
                      )}
                      <div className="w-20">
                        {msg?.image && (
                          <img src={msg?.image} alt="" className="w-full h-full object-scale-down" />
                        )}
                      </div>

                      {msg.sender === "Gemx" && loading && (
                        <div className="loader">
                          <hr />
                          <hr />
                          <hr />
                        </div>
                      )}

                      {(msg.sender === "Gemx" || msg.sender === "model") ? (
                        <button className="ml-2 mt-2">
                          {speak ? <PiSpeakerHigh className="text-gray-700 dark:hover:text-gray-400 size-5 hover:text-gray-400 dark:text-slate-200" onClick={() => { setSpeak(false); speakText(msg.text) }} /> : <PiSpeakerSlash className="text-gray-700 dark:hover:text-gray-400 size-5 hover:text-gray-400 dark:text-slate-200" onClick={() => {
                            setSpeak(true); if ('speechSynthesis' in window) {
                              window.speechSynthesis.cancel();
                            }
                          }} />}

                        </button>
                      ) : null}

                      
                    </div>
                    {msg.sender === "user" && (
                      <div className="flex-shrink-0">
                        <Avatar
                          width={40}
                          height={40}
                          name={user?.firstName}
                          imageUrl={user?.profile_pic}
                          userId=""
                          rounded
                        />
                      </div>
                    )}
                  </div>
                ))
                : messages.map((msg, index) => (
                  <div
                    key={index}
                    className={`flex items-start space-x-2 ${msg.sender === "user" ? "justify-end" : "justify-start"
                      }`}
                  >
                    {msg.sender !== "user" && (
                      <div className="flex-shrink-0">
                        <div
                          className={`h-6 w-6 md:h-10 md:w-10 rounded-full flex items-center justify-center text-white ${msg.sender === "user"
                            ? "dark:bg-custom bg-slate-200"
                            : "dark:bg-gray-800 bg-slate-300"
                            }`}
                        >
                          {msg.sender !== "user" ? <img src={logo} alt="G" /> : null}
                        </div>
                      </div>
                    )}
                    {/*  <button className="ml-2">
                      <FiEdit className="text-gray-300 hover:text-white" />
                    </button> */}
                    <div
                      className={`p-2 md:p-4 rounded-lg max-w-[80%] md:max-w-[65%] break-words ${msg.sender === "user"
                        ? "dark:bg-custom bg-slate-200 text-white rounded-full"
                        : "dark:bg-gray-800 bg-slate-300 text-white rounded-full"
                        }`}
                    >
                      {msg.sender === "Gemx" ? (
                        <div dangerouslySetInnerHTML={{ __html: msg.text }} />
                      ) : (
                        msg.text
                      )}
                       <div className="w-20">
                        {msg?.image && (
                          <img src={msg?.image} alt="" className="w-full h-full object-scale-down" />
                        )}
                      </div>
                      {msg.sender === "Gemx" && loading && (
                        <div className="loader">
                          <hr />
                          <hr />
                          <hr />
                        </div>
                      )}

{(msg.sender === "Gemx" || msg.sender === "model") ? (
                        <button className="ml-2 mt-2">
                          {speak ? <PiSpeakerHigh className="text-gray-700 dark:hover:text-gray-400 size-5 hover:text-gray-400 dark:text-slate-200" onClick={() => { setSpeak(false); speakText(msg.text) }} /> : <PiSpeakerSlash className="text-gray-700 dark:hover:text-gray-400 size-5 hover:text-gray-400 dark:text-slate-200" onClick={() => {
                            setSpeak(true); if ('speechSynthesis' in window) {
                              window.speechSynthesis.cancel();
                            }
                          }} />}

                        </button>
                      ) : null}
                      
                      {msg.sender === "user"}
                    </div>
                    {msg.sender === "user" && (
                      <div className="flex-shrink-0">
                        <Avatar
                          width={40}
                          height={40}
                          name={user?.firstName}
                          imageUrl={user?.profile_pic}
                          userId=""
                          rounded
                        />
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>

          {/* Input Form */}
          <div className="w-full px-4 pb-1 fixed bottom-0 left-0 right-0 bg-transparent ">
           
            <form
              className="flex items-center dark:bg-gray-800 bg-slate-200 p-2 rounded-3xl w-full max-w-[800px] mx-auto"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              {/* upload image display */}
              {uploadPhoto.imageUrl && (
                <div className="w-24 h-full bg-slate-500 bg-opacity-30 flex justify-center items-center rounded overflow-hidden">
                  <div className="bg-white p-1 relative">
                    <div
                      onClick={handleClearUploadPhoto}
                      className="cursor-pointer absolute flex justify-center items-center hover:bg-slate-200 rounded-full"
                    >
                      <IoIosClose />
                    </div>
                    <img
                      src={uploadPhoto.imageUrl}
                      width={40}
                      height={40}
                      alt="uploading"
                    />
                  </div>
                </div>
              )}

              <button
                onClick={handleFile}
                className="flex items-center justify-center bg-black p-2 rounded-full mr-2"
              >
                <FiPlus className="text-white" />
                <input
                  type="file"
                  onChange={handleUploadImage}
                  ref={uploadImageRef}
                  className="hidden"
                />
              </button>

              <TextareaAutosize
                className="dark:bg-gray-800 bg-slate-200 flex overflow-y-auto custom-scrollbar w-full resize-none p-1 text-white rounded-2xl border-none focus:border-none focus:ring-0 outline-none"
                placeholder="Questions here..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyPress={handleKeyPress}
                minRows={1}
                maxRows={7}
                style={{
                  wordWrap: "break-word",
                  outline: "none",
                  border: "none",
                }}
              />

              <button
                onClick={(e) => handleSend()}
                className="flex items-center justify-center bg-black p-2 rounded-full ml-2"
              >
                <FiArrowRight className="text-white" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chat;
